import { callRPC, HttpMethod } from "./rpc.service";

export async function getBudgetYear() {
  return await callRPC(HttpMethod.GET, "MasterData/BudgetYear");
}

export async function getMasterCatalogGroup() {
  return await callRPC(HttpMethod.GET, "MasterData/GetMasterCatalogGroup");
}

export async function getAccountCodeProduct() {
  return await callRPC(HttpMethod.GET, "MasterData/AccountCodeProduct");
}

export async function getPlan(departmentCode: string) {
  return await callRPC(HttpMethod.GET, `MasterData/Plan?departmentCode=${departmentCode}`);
}

export async function getSourceOfFunds() {
  return await callRPC(HttpMethod.GET, "MasterData/SourceOfFunds");
}
